import React, {Component} from "react";
import { injectIntl } from 'react-intl'
import EmptyFavorites from "./EmptyFavorites";
import EmptyShared from "./EmptyShared";
import EmptyLastUploaded from "./EmptyLastUploaded";
import EmptyExplore from "./EmptyExplore";
import {Empty} from "antd";

export class EmptyCollection extends Component {
    render(){
        const{
            keyCollection,
            intl
        } = this.props;
        return (
            keyCollection === "assetsFavorites" ? <EmptyFavorites/> :
        keyCollection === "assetsShared" ? <EmptyShared/> :
        keyCollection === "assetsExplore" ? <EmptyExplore/> :
        keyCollection === "assetsLastUploads" ? <EmptyLastUploaded/> : <Empty description={intl.formatMessage({ id: "no_data" })} />)
    }
}

export default injectIntl(EmptyCollection)